import { render, staticRenderFns } from "./security_deposits.vue?vue&type=template&id=640a5562&scoped=true"
import script from "./security_deposits.vue?vue&type=script&lang=js"
export * from "./security_deposits.vue?vue&type=script&lang=js"
import style0 from "./security_deposits.vue?vue&type=style&index=0&id=640a5562&prod&scoped=true&lang=css"
import style1 from "./security_deposits.vue?vue&type=style&index=1&id=640a5562&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640a5562",
  null
  
)

export default component.exports